import { usePurchaseDialog } from "@contexts/DialogContext/dialogs/purchase";
/* -----------------Child components--------------- */
import SessionConfigContainer from "@features/session-config/containers/SessionConfigContainer";
import Box from "@memorang/ui/components/Box";

const SessionCustomizeRoute = () => {
	const { showPurchase } = usePurchaseDialog();

	return (
		<Box flex={1}>
			<SessionConfigContainer
				onShowPurchase={() => showPurchase({ productType: "STUDY_PACK" })}
			/>
		</Box>
	);
};

export default SessionCustomizeRoute;
